import React from "react";

const Home: React.FC = () => {
  return (
    <iframe
      src="https://qwip-flow-mrzainhussain.replit.app"
      className="w-full h-screen border-0"
      title="qwip"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};

export default Home;
